import { useEffect, useMemo, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { AppShell } from "../../components/layout/AppShell";
import { ScopeBar } from "../../components/data/ScopeBar";
import { AcctNav } from "./AcctNav";
import { TABS } from "./acctTabs";
import { getAcctBranchId, setAcctBranchId } from "./acctScope";
import { setAcctCurrency } from "./useAcctCurrency";
import { listBranches } from "../../api/directory";

// قوقعة أب ثابتة للمحاسبة: AppShell + ScopeBar + التبويبات. تحفظ عملة الفرع الحالي.
export default function AcctLayout() {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const [branchId, setBranchId] = useState(() => getAcctBranchId());
  const [branches, setBranches] = useState([]);

  const currentKey = useMemo(() => {
    const match = [...TABS].sort((a, b) => b.to.length - a.to.length)
      .find((tab) => pathname === tab.to || pathname.startsWith(`${tab.to}/`));
    return match?.key || "dashboard";
  }, [pathname]);

  useEffect(() => { listBranches().then(setBranches).catch(() => setBranches([])); }, []);

  useEffect(() => {
    setAcctBranchId(branchId);
    const b = branches.find((row) => row.id === branchId);
    const cur = b?.primary_currency || b?.payroll?.currency || "AED";
    setAcctCurrency(cur);
  }, [branchId, branches]);

  return (
    <AppShell title={t("acct.title")} subtitle={t(`acct.tabs.${currentKey}`)}>
      <div className="grid gap-6">
        <ScopeBar value={branchId} onChange={setBranchId} testid="acct-scope" />
        <AcctNav />
        <div key={branchId || "all"}><Outlet /></div>
      </div>
    </AppShell>
  );
}
